import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { getTheme } from './utils/preferences';
import PrivateRoute from './components/PrivateRoute';
import CounterpartyLayout from './components/CounterpartyLayout';
import ToastContainer from './components/ToastContainer';
import Login from './pages/Login';
import DashboardPage from './pages/DashboardPage';
import RequestsPage from './pages/RequestsPage';
import TeamPage from './pages/TeamPage';
import TransactionHistoryPage from './pages/TransactionHistoryPage';
import SettingsPage from './pages/SettingsPage';

function LayoutWrapper() {
  return (
    <CounterpartyLayout>
      <Outlet />
    </CounterpartyLayout>
  );
}

export default function App() {
  useEffect(() => {
    const theme = getTheme();
    document.documentElement.classList.toggle('dark', theme === 'dark');
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route element={<PrivateRoute />}>
          <Route element={<LayoutWrapper />}>
            <Route path="/requests" element={<RequestsPage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/team" element={<TeamPage />} />
            <Route path="/transactions" element={<TransactionHistoryPage />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/rates" element={<Navigate to="/requests" replace />} />
          </Route>
        </Route>
        <Route path="/" element={<Navigate to="/requests" replace />} />
      </Routes>
      <ToastContainer />
    </BrowserRouter>
  );
}
